export default {
  base_url: '/api/illustrator/profile/portfolio/images',
  upload_image_url: '/api/illustrator/profile/portfolio/images/upload',
  replace_image_set_image_url: '/api/illustrator/profile/portfolio/replace-image',
  bulk_images_upload_url: '/api/illustrator/profile/portfolio/images/bulk-upload',

  store(form) {
    return form.post(this.base_url);
  },

  fetch(id, relationships) {
    return axios.get(`${this.base_url}/${id}`, {
      params: {
        relationships
      }
    }).then(response => response.data);
  },

  update(form, id) {
    return form.put(`${this.base_url}/${id}`);
  },

  updateWithAttachment(id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`${this.base_url}/${id}/update-with-attachment`, data).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};